import axios from "../services/api/api";
import { FormattedMessage } from "react-intl";
import moment from "moment";

/** HELPER FUNCTIONS **/

const errorMessage = (err) => {
  if (err && err.response) {
    return err.response.data;
  } else if (err && err.request) {
    return err.request.data;
  } else {
    return <FormattedMessage id="GenericApiError" />;
  }
};
/** END HELPER FUNCTIONS **/

export const HandlePurchaseAPLLicense = async (values) => {
  const data = await axios
    .post(
      `/Apl/PurchaseAplLicense?orderMessage=${values.licensesForPost.orderMessage}&invoiceLabeling=${values.licensesForPost.invoiceLabeling}&costCenter=${values.licensesForPost.costCenter}`,
      JSON.stringify(values.licensesForPost.studentEmails, null, 1)
    )
    .catch((err) => {
      if (err.response) {
        return err.response.data;
      } else if (err.request) {
        return err.request.data;
      } else {
        return <FormattedMessage id="GenericApiError" />;
      }
    });
  return data;
};

export const PostNotification = async (values) => {
  var myData = new FormData();
  myData.append("ImageFile", values.postObject.image);
  if (values.postObject.forSchools !== null) {
    values.postObject.forSchools.forEach((item) => {
      myData.append("SchoolIds", item);
    });
  }
  values.postObject.forLicenses.forEach((item) => {
    myData.append("ProgramIds", item);
  });
  myData.append("ShowForAllCustomers", values.postObject.showForAllCustomers);
  myData.append("ShowForTeachers", values.postObject.showForTeachers);
  myData.append("ShowForStudents", values.postObject.showForStudents);
  myData.append("ShowFrom", values.postObject.showFrom);
  myData.append("Title", values.postObject.title);
  myData.append("Text", values.postObject.text);
  myData.append("Video", values.postObject.video);
  myData.append("IsIntrusive", values.postObject.isIntrusive);

  const data = await axios
    .post(`/User/CreateNotice`, myData, {
      headers: { "Content-Type": "multipart/form-data;" },
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const UpdateNotification = async (values) => {
  var myData = new FormData();
  myData.append("ImageFile", values.postObject.image);
  myData.append("noticeId", values.postObject.noticeId);
  if (values.postObject.forSchools !== null) {
    values.postObject.forSchools.forEach((item) => {
      myData.append("SchoolIds", item);
    });
  }
  values.postObject.forLicenses.forEach((item) => {
    myData.append("ProgramIds", item);
  });
  myData.append("ShowForAllCustomers", values.postObject.showForAllCustomers);
  myData.append("ShowForTeachers", values.postObject.showForTeachers);
  myData.append("ShowForStudents", values.postObject.showForStudents);
  myData.append("ShowFrom", values.postObject.showFrom);
  myData.append("Title", values.postObject.title);
  myData.append("Text", values.postObject.text);
  myData.append("Video", values.postObject.video);
  myData.append("IsIntrusive", values.postObject.isIntrusive);
  myData.append("ImageOptions", values.postObject.imageOptions);
  const data = await axios
    .post(`/User/UpdateNotice`, myData, {
      headers: { "Content-Type": "multipart/form-data;" },
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const ToggleDeleteNotification = async (notification) => {
  const data = await axios
    .post(
      `/User/SetNoticeDeletedStatus?noticeId=${notification.notificationId}&isDeleted=${notification.isDeleted}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const SetCourseModuleSortOrder = async (postData) => {
  const data = await axios
    .post("/Course/SetModuleOrder", {
      ParentId: postData.courseId,
      SortedChildIds: postData.orderedModuleIds,
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const EditSchoolName = async (updateObject) => {
  const data = await axios
    .put(
      `/School/Update?schoolId=${updateObject.id}&name=${encodeURIComponent(
        updateObject.name
      )}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const MoveTeacherToSchoolAndClasses = async (updateObject) => {
  const data = await axios
    .post(
      `/User/MoveTeacher?teacherEmail=${encodeURIComponent(
        updateObject.teacherToMoveEmail
      )}&toSchoolFortNoxNumber=${updateObject.fortKnoxCustomerNumber}`
    )
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const AddProgramToSchool = async (updateObject) => {
  const data = axios
    .post(`/programme`, {
      name: updateObject.license.programName,
      customer: updateObject.school,
      costCenter: updateObject.license.fortNoxCostCenter,
    })
    .catch((err) => {
      return err;
    });
  return data;
};

export const AddProgramLicenseToSchool = async (updateObject) => {
  const validTo = moment().add(3, "y").format("YYYY-MM-DDTHH:mm:ss");
  const data = axios
    .post(
      `/ProgramLicense?customerId=${
        updateObject.school.id
      }&fortNoxNumber=${updateObject.license.fortNoxProgramLicenseNumber.trim()}&fortNoxNumberStudent=${updateObject.license.fortNoxStudentProgramLicenseNumber.trim()}&fortNoxCostCenter=${
        updateObject.license.fortNoxCostCenter
      }&validTo=${validTo}`
    )
    .catch((err) => {
      return err;
    });
  return data;
};

export const CreateSchoolAndAssignProgram = async (updateObject) => {
  const data = await axios
    .post(
      `/School/Create?customerNumber=${updateObject.fortKnoxCustomerNumber}`
    )
    .catch((err) => {
      return err;
    });
  return data;
};

export const CreateNewTeacher = async (postObject) => {
  const data = await axios
    .post(`/Teacher`, postObject.teacherToPost)
    .catch((err) => {
      return err;
    });
  return data;
};

export const AddTeacherToClass = async (postObject) => {
  const data = await axios
    .post(
      `/AddExistingTeacherToClass?teacherId=${
        postObject.teacherId
      }&classIds=${postObject.classIds.join("&classIds=")}`
    )
    .catch((err) => {
      return err;
    });
  return data;
};

export const AddClassToSchool = async (postObject) => {
  const data = await axios
    .post("/class", {
      name: postObject.name,
      school: postObject.school,
      programme: postObject.selectedProgramme,
      orientation: { id: 0, name: postObject.selectedOrientation },
    })
    .catch((err) => {
      return err;
    });
  return data;
};

export const CreateNewScormLicenseCustomer = async (postObject) => {
  const data = await axios
    .post(
      `/LicMgt/CreateCustomer?FortNoxNumber=${postObject.fortnoxNumber}&Url=${postObject.url}&ContactName=${postObject.contactName}&ContactMail=${postObject.contactMail}`
    )
    .catch((err) => {
      return err;
    });
  return data;
};

export const CreateNewScormLicenseCourse = async (postObject) => {
  const data = await axios
    .post(
      `/LicMgt/CreateCourse?Name=${postObject.name}&identifier=${postObject.identifier}&AdditionalInfo=${postObject.additionalInfo}`
    )
    .catch((err) => {
      return err;
    });
  return data;
};

export const CreateNewScormLicenseLicenses = async (postObject) => {
  const data = await axios
    .post(
      `/LicMgt/CreateLicenses?CourseId=${postObject.courseId}&CustomerId=${postObject.customerId}&Quantity=${postObject.quantity}`
    )
    .catch((err) => {
      return err;
    });
  return data;
};

export const UpdateLicenseCustomer = async (postObject) => {
  const data = await axios
    .post(
      `/LicMgt/UpdateCustomer?FortNoxNumber=${postObject.fortnoxNumber}&Url=${postObject.url}&ContactName=${postObject.contactName}&ContactMail=${postObject.contactMail}`
    )
    .catch((err) => {
      return err;
    });
  return data;
};

export const UpdateLicenseCourse = async (postObject) => {
  const data = await axios
    .post(
      `/LicMgt/UpdateCourse?Id=${postObject.id}&Identifier=${postObject.identifier}&Name=${postObject.name}&AdditionalInfo=${postObject.additionalInfo}`
    )
    .catch((err) => {
      return err;
    });
  return data;
};

export const SetCourseSortOrder = async (postData) => {
  const data = await axios
    .post("/Course/SetCourseOrder", {
      ParentId: postData.programId,
      SortedChildIds: postData.orderedCourseIds,
    })
    .catch((err) => {
      return errorMessage(err);
    });
  return data;
};

export const AddNewProgram = async (postData) => {
  const data = await axios
    .post(`/ProgramLicense/AddFortNoxProgram`, postData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .catch((err) => {
      return err;
    });
  return data;
};

export const EditProgramLicense = async (postData) => {
  const data = await axios
    .put(`/ProgramLicense/EditFortNoxProgram`, postData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .catch((err) => {
      return err;
    });
  return data;
};

export const EditSchoolGrouping = async (postData) => {
  const data = await axios
    .put(
      `/School/EditSchoolGrouping`,
      JSON.stringify(postData.customers, null, 1),
      { headers: { "Content-Type": "application/json" } }
    )
    .catch((err) => {
      return err;
    });
  return data;
};

export const EditSchoolGroupName = async (postData) => {
  const data = await axios
    .put(`/School/EditGroup`, { Id: postData.id, Name: postData.name })
    .catch((err) => {
      return err;
    });
  return data;
};

export const CreateSchoolGroup = async (postData) => {
  const data = await axios
    .post(`/School/CreateGroup/${postData.name}`)
    .catch((err) => {
      return err;
    });
  return data;
};

export const DeleteSchoolGroup = async (postData) => {
  const data = await axios
    .delete(`/School/DeleteSchoolGroup?groupId=${postData.groupId}`)
    .catch((err) => {
      return err;
    });
  return data;
};
